import * as type from '../mutation-types';
import { createActionHelpers } from 'vuex-loading';

const { startLoading, endLoading } = createActionHelpers({
    moduleName: 'loading',
});

const state = {
    searchMeta: null,
    pwpSearchMeta: null,
    filters: [],
    lastQuery: null,
    promotionList: [],
    promotionCategories: [],
    promotionTypes: [],
};

const getters = {
    filters(state) {
        return state.filters;
    },

    promotionList: state => {
        return state.promotionList;
    },
};

const mutations = {
    setSearchMeta(state, meta) {
        state.searchMeta = meta;
    },

    setPwpSearchMeta(state, meta) {
        state.pwpSearchMeta = meta;
    },

    setFilters(state, filters) {
        console.log('setfilters');
        state.filters = filters;
    },

    [type.SET_PROMOTION_LIST](state, promotionList) {
        state.promotionList = promotionList;
    },

    setPromotionCategories(state, promotionCategories) {
        state.promotionCategories = promotionCategories;
    },

    setPromotionTypes(state, promotionTypes) {
        state.promotionTypes = promotionTypes;
    },

    setLastQuery(state, query) {
        state.lastQuery = query;
    },
};

const actions = {
    getSearchMeta({ commit, dispatch }) {
        let route = Laroute.route(
            'franchise.report.non_fuel.promotion.search.meta',
        );

        startLoading(dispatch, 'get-promotion-meta');

        return axios
            .get(route)
            .then(res => {
                commit('setSearchMeta', res.data);
                endLoading(dispatch, 'get-promotion-meta');
                return res.data;
            })
            .catch(err => {
                endLoading(dispatch, 'get-promotion-meta');
                throw err;
            });
    },

    getSearchMetaIfNecessary({ commit, dispatch }) {
        if (!state.searchMeta) {
            return dispatch('getSearchMeta');
        }

        return Promise.resolve(state.searchMeta);
    },

    getPwpSearchMeta({ commit, dispatch }) {
        let route = Laroute.route(
            'franchise.report.non_fuel.pwp_promotion.search.meta',
        );

        startLoading(dispatch, 'get-pwp-promotion-meta');

        return axios
            .get(route)
            .then(res => {
                commit('setPwpSearchMeta', res.data);
                endLoading(dispatch, 'get-pwp-promotion-meta');
                return res.data;
            })
            .catch(err => {
                endLoading(dispatch, 'get-pwp-promotion-meta');
                throw err;
            });
    },

    getPwpSearchMetaIfNecessary({ commit, dispatch }) {
        if (!state.searchMeta) {
            return dispatch('getPwpSearchMeta');
        }

        return Promise.resolve(state.pwpSearchMeta);
    },

    getPromotionList({ commit, dispatch }, params = {}) {
        let options = {
            params: _.merge(
                {
                    limit: 50,
                    maxprice: 1,
                },
                params,
            ),
        };

        startLoading(dispatch, 'fetch-promotion');

        let api = Laroute.route('franchise.vue.get.promotions');

        return axios
            .get(api, options)
            .then(res => {
                let data = res.data.data;

                commit('setLastQuery', params.query);
                commit(type.SET_PROMOTION_LIST, data);
                endLoading(dispatch, 'fetch-promotion');

                return data;
            })
            .catch(err => {
                endLoading(dispatch, 'fetch-promotion');
                throw err;
            });
    },

    getPromotionListIfNecessary({ commit, dispatch }, params = {}) {
        if (!state.promotionList.length || state.lastQuery !== params.query) {
            return dispatch('getPromotionList', params);
        }

        return Promise.resolve(state.promotionList);
    },

    getPromotionCategories({ commit, dispatch }, params = {}) {
        let options = {
            params: _.merge(
                {
                    limit: 50,
                    maxprice: 1,
                },
                params,
            ),
        };

        startLoading(dispatch, 'fetch-promotion-categories');

        let api = Laroute.route('franchise.vue.receipt-promotion.categories');
        return axios
            .get(api, options)
            .then(res => {
                let data = res.data.data;

                commit('setLastQuery', params.query);
                commit('setPromotionCategories', data);
                endLoading(dispatch, 'fetch-promotion-categories');

                return data;
            })
            .catch(err => {
                endLoading(dispatch, 'fetch-promotion-categories');
                throw err;
            });
    },

    getPromotionCategoriesIfNecessary({ commit, dispatch }, params = {}) {
        if (
            !state.promotionCategories.length ||
            state.lastQuery !== params.query
        ) {
            return dispatch('getPromotionCategories', params);
        }

        return Promise.resolve(state.promotionCategories);
    },

    getPromotionTypes({ commit, dispatch }, params = {}) {
        let options = {
            params: _.merge(
                {
                    limit: 50,
                    maxprice: 1,
                },
                params,
            ),
        };

        startLoading(dispatch, 'fetch-promotion-types');

        let api = Laroute.route('franchise.vue.receipt-promotion.types');

        return axios
            .get(api, options)
            .then(res => {
                let data = res.data.data;

                commit('setLastQuery', params.query);
                commit('setPromotionTypes', data);
                endLoading(dispatch, 'fetch-promotion-types');

                return data;
            })
            .catch(err => {
                endLoading(dispatch, 'fetch-promotion-types');
                throw err;
            });
    },

    getPromotionTypesIfNecessary({ commit, dispatch }, params = {}) {
        if (!state.promotionTypes.length || state.lastQuery !== params.query) {
            return dispatch('getPromotionTypes', params);
        }

        return Promise.resolve(state.promotionTypes);
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/receipt-promotion.js